import RestClientService from "@/core/services/restClient.service";
import { ICoreResponse } from "@/core/interfaces/coreResponse.interface";
import { CHURNING_API_PATH, ChurningQueryPayload } from "../constants";
import { ChurningRecord } from "@/modules/Churning/interfaces/churningResponse.interface";

class ChurningService {
  private restClient: RestClientService;

  constructor() {
    this.restClient = new RestClientService();
  }

  public fetchChurning(
    params: ChurningQueryPayload,
  ): Promise<ICoreResponse<ChurningRecord[] | null>> {
    return this.restClient.get(CHURNING_API_PATH.LIST, params);
  }
}

export default ChurningService;
